import './intervention-axes.css'
import { useState, useRef } from 'react'

export default function InterventionAxes() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)
  const containerRef = useRef(null)

  const axes = [
    {
      title: 'EDUCACIÓN',
      description: 'Desarrollamos procesos educativos sociocomunitarios, en ámbitos laborales y académicos. Además creamos materiales pedagógicos y guías técnicas.',
      link: '/educacion',
      linkText: 'Ver más'
    },
    {
      title: 'INVESTIGACIÓN',
      description: 'Impulsamos y participamos en estudios propios y colaboraciones. Además, mantenemos una revisión crítica y continua del conocimiento con perspectiva feminista para fundamentar nuestra acción.',
      link: '/investigacion',
      linkText: 'Ver más'
    },
    {
      title: 'DIVULGACIÓN',
      description: 'Participamos en charlas, jornadas y seminarios para acercar el conocimiento sobre la menstruación, el ciclo y el climaterio a públicos amplios. Creamos materiales divulgativos propios — libro, fanzines, artículos — recogidos en nuestra página Publicaciones.',
      link: '/publicaciones',
      linkText: 'Ver publicaciones'
    },
    {
      title: 'ACTIVISMO',
      description: 'El activismo menstrual constituye una práctica política que, mediante diversas acciones busca erradicar la pobreza menstrual y las violencias que atraviesan la trayectoria vital, desde la menarquia hasta la menopausia.',
      link: '/activismo',
      linkText: 'Ver más'
    },
    {
      title: 'RED',
      description: 'Tejemos colectividad en torno a la cultura menstrual, conectando proyectos, cooperativas, entidades y personas. En nuestras Memorias anuales queda recogido todo ese tejido.',
      link: '/red',
      linkText: 'Ver más'
    }
  ]

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = (e) => {
    setTouchEnd(e.changedTouches[0].clientX)
    handleSwipe()
  }

  const handleSwipe = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > 50
    const isRightSwipe = distance < -50

    if (isLeftSwipe && currentIndex < axes.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
    if (isRightSwipe && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }

  const goToNext = () => {
    if (currentIndex < axes.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
  }

  const goToPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }

  return (
    <section className='intervention-axes' id='intervention-axes'>
      {/* Desktop View */}
      <div className='intervention-axes__desktop'>
        <div className='intervention-axes__container'>
          {/* HEADER CENTRAL */}
          <div className='intervention-axes__header-center'>
            <h1 className='intervention-axes__header-title main-color'>Ejes de intervención</h1>
          </div>

          {/* EDUCACIÓN - Arriba Centro */}
          <div className='intervention-axes__box intervention-axes__box--educacion'>
            <h3 className='intervention-axes__title'>EDUCACIÓN</h3>
            <p className='intervention-axes__description'>
              Desarrollamos procesos educativos sociocomunitarios, en ámbitos laborales y académicos. Además creamos materiales pedagógicos y guías técnicas.
            </p>
            <a className='intervention-axes__link' href='/educacion'>Ver más</a>
          </div>

          {/* INVESTIGACIÓN - Arriba Derecha */}
          <div className='intervention-axes__box intervention-axes__box--investigacion'>
            <h3 className='intervention-axes__title'>INVESTIGACIÓN</h3>
            <p className='intervention-axes__description'>
              Impulsamos y participamos en estudios propios y colaboraciones. Además, mantenemos una revisión crítica y continua del conocimiento con perspectiva feminista para fundamentar nuestra acción.
            </p>
            <a className='intervention-axes__link' href='/investigacion'>Ver más</a>
          </div>

          {/* DIVULGACIÓN - Izquierda Centro */}
          <div className='intervention-axes__box intervention-axes__box--divulgacion'>
            <h3 className='intervention-axes__title'>DIVULGACIÓN</h3>
            <p className='intervention-axes__description'>
              Participamos en charlas, jornadas y seminarios para acercar el conocimiento sobre la menstruación, el ciclo y el climaterio a públicos amplios. Creamos materiales divulgativos propios — libro, fanzines, artículos — recogidos en nuestra página Publicaciones.
            </p>
            <a className='intervention-axes__link' href='/publicaciones'>Ver publicaciones</a>
          </div>

          {/* ACTIVISMO - Abajo Derecha */}
          <div className='intervention-axes__box intervention-axes__box--activismo'>
            <h3 className='intervention-axes__title'>ACTIVISMO</h3>
            <p className='intervention-axes__description'>
              El activismo menstrual constituye una práctica política que, mediante diversas acciones busca erradicar la pobreza menstrual y las violencias que atraviesan la trayectoria vital, desde la menarquia hasta la menopausia.
            </p>
            <a className='intervention-axes__link' href='/activismo'>Ver más</a>
          </div>

          {/* RED - Abajo Izquierda */}
          <div className='intervention-axes__box intervention-axes__box--red'>
            <h3 className='intervention-axes__title'>RED</h3>
            <p className='intervention-axes__description'>
              Tejemos colectividad en torno a la cultura menstrual, conectando proyectos, cooperativas, entidades y personas. En nuestras Memorias anuales queda recogido todo ese tejido.
            </p>
            <a className='intervention-axes__link' href='/red'>Ver más</a>
          </div>
        </div>
      </div>

      {/* Mobile Carousel View */}
      <div
        className='intervention-axes__mobile'
        ref={containerRef}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className='intervention-axes__mobile-header'>
          <h2 className='intervention-axes__mobile-heading'>Ejes</h2>
        </div>

        <div className='intervention-axes__carousel'>
          <div
            className='intervention-axes__carousel-track'
            style={{
              transform: `translateX(calc(-${currentIndex * 100}%))`
            }}
          >
            {axes.map((axis, index) => (
              <div key={index} className='intervention-axes__carousel-slide'>
                <div className='intervention-axes__mobile-box'>
                  <h3 className='intervention-axes__mobile-title'>{axis.title}</h3>
                  <p className='intervention-axes__mobile-description'>{axis.description}</p>
                  {axis.link ? (
                    <a className='intervention-axes__link intervention-axes__link--mobile' href={axis.link}>
                      {axis.linkText || 'Ver más'}
                    </a>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Carousel Navigation */}
        <div className='intervention-axes__swipe-hint'>
          ← Desliza para explorar →
        </div>

        <div className='intervention-axes__carousel-dots'>
          {axes.map((_, index) => (
            <button
              key={index}
              className={`intervention-axes__dot ${
                index === currentIndex ? 'intervention-axes__dot--active' : ''
              }`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Ir al eje ${index + 1}`}
            />
          ))}
        </div>

        <div className='intervention-axes__carousel-buttons'>
          <button
            className='intervention-axes__carousel-btn'
            onClick={goToPrev}
            disabled={currentIndex === 0}
            aria-label='Eje anterior'
          >
            ←
          </button>
          <button
            className='intervention-axes__carousel-btn'
            onClick={goToNext}
            disabled={currentIndex === axes.length - 1}
            aria-label='Siguiente eje'
          >
            →
          </button>
        </div>
      </div>
    </section>
  )
}
